// extracted by mini-css-extract-plugin
module.exports = {"Container":"Loading_Container__2tXXd","Text":"Loading_Text__3XeS2","ShowOpacity":"Loading_ShowOpacity__Y8FsQ"};